import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import type { MappingTrace, MappingTraceCorrectionRequest } from 'shared/products/mapping/domain/mappingTrace';
import { useMappingTraceStore } from 'shared/products/mapping/stores/mappingTraceStore';

export interface UpdateMappingTraceResponse {
  ok: true;
  mappingTrace: MappingTrace;
}

export function useUpdateMappingTrace() {
  const store = useMappingTraceStore();

  return useUpdateEntityApi<MappingTraceCorrectionRequest, UpdateMappingTraceResponse>({
    url: 'mappingTrace',
    translate: (t) => t.products.actions.update,
    async processOk(response) {
      const json = await response.json() as MappingTrace;
      store.add(json);

      return {
        ok: true,
        mappingTrace: json,
      };
    },
  });
}
